import {Component} from '@angular/core';

@Component({
    selector: 'kkk-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent {
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/footer/footer.component.ts